module.exports = __webpack_public_path__ + "static/media/earth.67af05e1.jpg";